// extracted by mini-css-extract-plugin
module.exports = {"ingredients":"section-ingredients_ingredients__3Wduw"};